import { CloudflareAsset, LanguageKey, LanguageLabel } from "@/shared/common/enums";

export const languagesOptions = [
  {
    label: LanguageLabel.Hay,
    value: LanguageKey.Hy,
    icon: CloudflareAsset.ARM,
  },
  {
    label: LanguageLabel.Eng,
    value: LanguageKey.En,
    icon: CloudflareAsset.GBR,
  },
  {
    label: LanguageLabel.Rus,
    value: LanguageKey.Ru,
    icon: CloudflareAsset.RUS,
  },
];
